<template>
    <div class="single__vat" v-if="$store.getters.currentItemVariation" @click="toggleSidebar">
          <span><template v-if="inclShipping">inkl.</template><template v-else>zzgl.</template> <u>Versandkosten</u></span>
    </div>
</template>

<script>
    import TranslationService from "ceres/app/services/TranslationService"

    export default {
        props:{
            link: {
                type: String,
                default: "/weberbuero/versandkosten"
            }
        },

        methods: {
          toggleSidebar(){
            document.body.classList.toggle("service-sidebar--open");
          },
        },

        computed: {
            showNetPrices(){
                return App.initialData.showNetPrices;
            },

            highestCosts(){
              let costs = 0;
              costs = this.$store.getters.currentItemVariation.variation.defaultShippingCosts;
              return costs
            },


            inclShipping(){
              return App.shippingIncl.includes("" + this.highestCosts)
            },

            formattedShippingPrice(){
                const shippingCosts = this.$store.getters.currentItemVariation.variation.defaultShippingCosts;
                if (shippingCosts > 0){
                    return shippingCosts.toLocaleString('de-DE', {style:'currency', currency: "EUR"});
                }
                return '0';
            },

            combiShippingText(){
                const extraShipping = this.$store.getters.currentItemVariation.variation.extraShippingCharge2;
                if (extraShipping > 0){
                    return TranslationService.translate("Weberbuero::Template.singleShippingSecondItem", {"value": extraShipping.toLocaleString('de-DE', {style:'currency', currency: "EUR"})});
                }
                return TranslationService.translate("Weberbuero::Template.singleShippingSecondItemFree");
            },

            ShippingText(){
                if( this.$store.getters.currentItemVariation.variation.defaultShippingCosts > 0){
                    return TranslationService.translate("Weberbuero::Template.singleItemShippingCostsWithPrice", {"value": this.formattedShippingPrice });
                }else{
                    return TranslationService.translate("Weberbuero::Template.singleItemShippingCostsPriceIncluded");
                }

            },

        }
    }
</script>
